import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';

import AutoScroller from '../components/autoScroller';
import PersonCard from '../components/personCard';

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
`;

const GridItem = styled.div`
  flex: 0 0 ${100 / 3}%;
  max-width: ${100 / 3}%;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
`;

const StyledPersonCard = styled(PersonCard)`
  height: 100%;
`;

// TODO 264 Keep person displayed after un-select?
// - Hide only after all people changes (eg. user uses search input).
// - Quite hard to implement, leaving the prototype here for now.
// - Algoritmus:
//   - Když se people nezmění: Přidat k allPeople všechny people ze selectedPeople, které tam nejsou. Ale nemazat ty, které byly odebrány.
//   - Když se people změní: allPeople = selectedPeople + people
// const [allPeople, setAllPeople] = useState(getAllPeople(people, selectedPeople));
// const previousPeople = usePrevious(people);
// useEffect(() => {
//   if (people !== previousPeople) {
//     setAllPeople(getAllPeople(people, selectedPeople));
//     return;
//   }
//   ...
// }, [people, previousPeople, selectedPeople]);

// TODO 264 Add "select all" and "unselect all" buttons. Maybe, low priority
const PersonCardMultiSelect = memo(
  ({ className, onRemove, onSelect, people, selectedPeople, personRenderer }) => {
    // Transform people and selectedPeople into single list of people and "is selected" flags.
    // Also, include selectedPeople missing in people at the start of the list.
    const items = useMemo(() => {
      // TODO 264 Optimize performance by using maps by ID rather than find and filter.
      // const peopleById = groupBy(people, 'id');
      // const selectedPeopleById = groupBy(people, 'id');
      // List of people is transformed into their items and list of selected people that was missing.
      const { missingSelectedPeople, peopleItems } = people.reduce(
        (acc, person) => ({
          missingSelectedPeople: acc.missingSelectedPeople.filter(
            missingPerson => missingPerson.id !== person.id,
          ),
          peopleItems: [
            ...acc.peopleItems,
            {
              isSelected: Boolean(
                selectedPeople.find(selectedPerson => selectedPerson.id === person.id),
              ),
              person,
            },
          ],
        }),
        {
          missingSelectedPeople: selectedPeople,
          peopleItems: [],
        },
      );
      // Transform missing selected people into items. All of them are obviously selected.
      const missingSelectedItems = missingSelectedPeople.map(missingPerson => ({
        isSelected: true,
        person: missingPerson,
      }));
      // Place the missing selected items before items created from people list.
      return [...missingSelectedItems, ...peopleItems];
    }, [people, selectedPeople]);

    if (items.length === 0) {
      return null;
    }

    return (
      <AutoScroller className={className}>
        <Grid>
          {items.map(({ isSelected, person }) => (
            <GridItem key={person.id}>
              <StyledPersonCard
                isSelected={isSelected}
                onRemove={onRemove}
                disabled={personRenderer(person)}
                onSelect={onSelect}
                person={person}
              />
            </GridItem>
          ))}
        </Grid>
      </AutoScroller>
    );
  },
);

PersonCardMultiSelect.defaultProps = {
  className: undefined,
  onRemove: () => {},
  onSelect: () => {},
  people: [],
  selectedPeople: [],
  personRenderer: () => undefined,
};

PersonCardMultiSelect.propTypes = {
  className: PropTypes.string,
  onRemove: PropTypes.func,
  onSelect: PropTypes.func,
  people: PropTypes.arrayOf(PropTypes.object),
  selectedPeople: PropTypes.arrayOf(PropTypes.object),
};

export default PersonCardMultiSelect;
